var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:_vm.color},[_c('span',[_vm._v("Sensor 0"+_vm._s(_vm.item.mic)+":")]),_c('p',{staticStyle:{"color":"black"}},[_vm._v(_vm._s(_vm.cough_count))])])}
var staticRenderFns = []

export { render, staticRenderFns }